
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/category/new",
      function () {
        return require("private-next-pages/category/new.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/category/new"])
      });
    }
  